import CRXCoachConfigurations from './CRXCoachConfigurations';

export default CRXCoachConfigurations;
